var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffce52;}.cls-2{fill:#ffe369;}.cls-3{fill:#ffb32b;}.cls-4{fill:#f6fafd;}.cls-5{fill:#273941;}.cls-6{fill:#ae2d4c;}.cls-7{fill:#cf4054;}.cls-8{fill:#141e21;}.cls-9{fill:#8a293d;}.cls-10{fill:#fbb40a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13-love") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_13-love",
    "data-name": "13-love"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24,
    cy: 24,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,4c12.15,0,22,8.507,22,19h.975a23,23,0,0,0-45.95,0H2C2,12.507,11.85,4,24,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,23c0,10.493-9.85,19-22,19S2,33.493,2,23H1.025c-.014.332-.025.665-.025,1a23,23,0,0,0,46,0c0-.335-.011-.668-.025-1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 37,
    cy: 9,
    rx: 0.825,
    ry: 1.148,
    transform: "translate(4.48 28.81) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 30.746,
    cy: 4.5,
    rx: 0.413,
    ry: 0.574,
    transform: "translate(5.829 23.067) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 34,
    cy: 7,
    rx: 1.65,
    ry: 2.297,
    transform: "translate(5.015 26.102) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34,39c0-2.76-4.47-5-10-5s-10,2.24-10,5l-.1.13A10.727,10.727,0,0,1,9,30.15,2.025,2.025,0,0,1,10.87,28c1.88,1.08,6.39,1,13.13,1s11.25.08,13.12-1A2.026,2.026,0,0,1,39,30.15a10.727,10.727,0,0,1-4.9,8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34,39l.1.13A17.882,17.882,0,0,1,24,42a17.882,17.882,0,0,1-10.1-2.87L14,39c0-2.76,4.47-5,10-5S34,36.24,34,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16.5,9A4.465,4.465,0,0,1,21,13.8C21,21,13.5,25,12,25c-.72,0-8.38-3.7-8.97-10.39Q3,14.205,3,13.8A4.451,4.451,0,0,1,6.58,9.1,4.053,4.053,0,0,1,7.5,9c2.25,0,3.75,1.6,4.5,4C12.75,10.6,14.25,9,16.5,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45,13.8q0,.4-.03.81C44.44,21.3,37.44,25,36,25c-.75,0-9-4-9-11.2A4.465,4.465,0,0,1,31.5,9c2.25,0,3.75,1.6,4.5,4,.75-2.4,2.25-4,4.5-4a4.053,4.053,0,0,1,.92.1A4.451,4.451,0,0,1,45,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M10.87,30c1.88,1.08,6.39,1,13.13,1s11.25.08,13.12-1a1.926,1.926,0,0,1,1.793,1.536A11.043,11.043,0,0,0,39,30.15,2.026,2.026,0,0,0,37.12,28c-1.87,1.08-6.38,1-13.12,1s-11.25.08-13.13-1A2.025,2.025,0,0,0,9,30.15a11.015,11.015,0,0,0,.087,1.385A1.92,1.92,0,0,1,10.87,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.531,37.486A18.171,18.171,0,0,1,24,40a18.171,18.171,0,0,1-9.531-2.514A2.809,2.809,0,0,0,14,39l-.1.13A17.882,17.882,0,0,0,24,42a17.882,17.882,0,0,0,10.1-2.87L34,39A2.809,2.809,0,0,0,33.531,37.486Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M36,25c-.71,0-8.131-3.59-8.921-10.081A6,6,0,0,0,27,15.8C27,23,35.25,27,36,27c1.44,0,8.44-3.7,8.97-10.39Q45,16.2,45,15.8a6.079,6.079,0,0,0-.07-.907C44.225,21.4,37.419,25,36,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M12,25c-.71,0-8.131-3.59-8.921-10.081A6,6,0,0,0,3,15.8C3,23,11.25,27,12,27c1.44,0,8.44-3.7,8.97-10.39Q21,16.2,21,15.8a6.079,6.079,0,0,0-.07-.907C20.225,21.4,13.419,25,12,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.5,9c-2.25,0-3.75,1.6-4.5,4,.583-1.8,1.75-3,3.5-3A3.408,3.408,0,0,1,43,13.6C43,19,37.167,22,36,22c-.56,0-6.518-2.775-6.977-7.793-.015-.2-.023-.405-.023-.607a3.366,3.366,0,0,1,2.784-3.525A3.243,3.243,0,0,1,32.5,10c1.75,0,2.917,1.2,3.5,3-.75-2.4-2.25-4-4.5-4a4.053,4.053,0,0,0-.92.1A4.451,4.451,0,0,0,27,13.8q0,.4.03.81C27.62,21.3,35.28,25,36,25c1.5,0,9-4,9-11.2A4.465,4.465,0,0,0,40.5,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.5,9c-2.25,0-3.75,1.6-4.5,4,.583-1.8,1.75-3,3.5-3A3.408,3.408,0,0,1,19,13.6C19,19,13.167,22,12,22c-.56,0-6.518-2.775-6.977-7.793C5.008,14.005,5,13.8,5,13.6a3.366,3.366,0,0,1,2.784-3.525A3.243,3.243,0,0,1,8.5,10c1.75,0,2.917,1.2,3.5,3-.75-2.4-2.25-4-4.5-4a4.053,4.053,0,0,0-.92.1A4.451,4.451,0,0,0,3,13.8q0,.4.03.81C3.62,21.3,11.28,25,12,25c1.5,0,9-4,9-11.2A4.465,4.465,0,0,0,16.5,9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 42,
    cy: 13,
    rx: 0.825,
    ry: 1.148,
    transform: "translate(3.116 33.519) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 40.746,
    cy: 11.5,
    rx: 0.413,
    ry: 0.574,
    transform: "translate(3.809 32.193) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 18,
    cy: 13,
    rx: 0.825,
    ry: 1.148,
    transform: "translate(-3.919 16.543) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 16.746,
    cy: 11.5,
    rx: 0.413,
    ry: 0.574,
    transform: "translate(-3.226 15.216) rotate(-45.02)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.b2f8dea0ba8a0a269fe47790f8226833.svg";
export { ForwardRef as ReactComponent };